<div class="flex h-full" [class]="(workspaceId && hasToggleOn$ | async) ? 'w-full' : 'w-full'">
  @if(workspaceId && hasToggleOn$ | async){
    <div class="nav w-[253px]">
      <nav class="w-full">
        <ul class="w-full pt-[60px]">
          @for (user of worksapceUsers; track user; let index = $index; let last = $last) {
            <li
              class="app__stepper__config-stepitem"
          [ngClass]="{
            'app__stepper__config-stepitem-selected border-l-0': user?.status == 'active',
            block: user.toggle === 'on',
            hidden: user.toggle === 'off'
          }"
              (click)="handleSidenavMenuNavigation(user.user_id, user.toggle, index)"
              >
              {{ user.name }}
            </li>
          }
        </ul>
      </nav>
    </div>
  }
  <div class="h-full" [class]="(workspaceId && hasToggleOn$ | async) ? 'w-[calc(100%-253px)]' : 'w-full'">
    @if(!isFromDiscovery){
      <header class="drawer-header">
        <h3 class="drawer-header__title">Live Data Feeds For Financial Institutions</h3>
        <button type="button" class="drawer-header__close" aria-label="Close" matTooltipPosition="above" (click)="closeSideDrawer()">
          <span class="material-icons" aria-hidden="true">clear</span>
        </button>
      </header>
    }
    <div
      class="w-full overflow-hidden bg-[#FAFAFA]"
      [ngClass]="{ 'py-11': isFromDiscovery, 'py-[42px]': !isFromDiscovery, 'h-[calc(100%-4rem)]': !switchFromUser, 'h-[calc(100%-6rem)]': switchFromUser }"
      >
      <div class="h-full">
        <div [ngClass]="{ 'px-0': isFromDiscovery, 'px-[32px]': !isFromDiscovery }">
          <div class="app__centered-item app__form--attribute--title justify-between text-sm" [ngClass]="{ 'w-[794px]': isFromDiscovery }">
            <p class="m-0">
              {{ isFromDiscovery ? 'Financial Integrations' : 'All Connected Financial Institutions' }}
              <span class="text-k-blue">({{ mxDatList().length }})</span>
            </p>
            @if((!workspaceId || worksapceUsers[currentActiveIndex]?.toggle == 'on') && !isFromDiscovery){
              <div class="flex justify-center gap-2">
                <button type="button" class="btn integration-success" (click)="addInstitutionThroughPlaid()">
                  Connect with <img src="/assets/images/plaid-new-black-icon.svg" alt="" />
                </button>
                <button type="button" class="btn integration-success" (click)="addInstitution()">
                  Connect with <img src="/assets/images/mx-new-black-icon.svg" alt="" />
                </button>
              </div>
              }@else if(mxDatList().length > 0){
              <div class="flex justify-center gap-2">
                <button type="button" class="btn integration-success" (click)="addInstitutionThroughPlaid()">
                  Connect with <img src="/assets/images/plaid-new-black-icon.svg" alt="" />
                </button>
                <button type="button" class="btn integration-success" (click)="addInstitution()">
                  Connect with <img src="/assets/images/mx-new-black-icon.svg" alt="" />
                </button>
              </div>

            }
          </div>
          @if(!isFromDiscovery){
            <div class="app__form--attribute--title flex items-center text-[12px] font-medium gap-2 mt-6">
              <div class="p-4 w-[50%] rounded-[10px] flex items-center justify-between border border-[#6bd489b3] bg-[#F4FFF7]">
                <p class="flex items-center gap-1 m-0">
                  <span class="w-[10px] h-[10px] rounded-sm border border-[#5F5F5F] bg-[#6BD489]"></span>
                  Connected
                </p>
                <p class="m-0 font-bold">{{ connectedAccounts().length }}</p>
              </div>
              <div class="p-4 w-[50%] rounded-[10px] flex items-center justify-between border border-[#fe8a66b3] bg-[#FDEAE5]">
                <p class="flex items-center gap-1 m-0">
                  <span class="w-[10px] h-[10px] rounded-sm border border-[#5F5F5F] bg-[#FE8A66]"></span>
                  Disconnected
                </p>
                <p class="m-0 font-bold">{{ disconnectedAccounts().length }}</p>
              </div>
            </div>
          }
        </div>

        @if (!isLoadingData()) {
          <div class="add-subfolder--container w-full m-0 p-0 bg-[#FAFAFA]" [ngClass]="{ 'mt-4': mxDatList().length > 0 }">
            @if (mxDatList().length > 0) {
              <div class="h-full mb-4" [ngClass]="{ 'pr-[16px]': !isFromDiscovery }">
                <div
                  class="overflow-y-auto flex flex-col gap-4"
              [ngClass]="{
                'px-0 max-h-[calc(100vh-454px)] w-[812px]': isFromDiscovery && switchFromUser,
                'px-0 max-h-[calc(100vh-402px)] w-[812px]': isFromDiscovery && !switchFromUser,
                'pl-[32px] pb-10 max-h-[80%]': !isFromDiscovery
              }"
                  >
                  @for (account of mxDatList(); track account; let i = $index) {
                    <div class="asset-list-group" [ngClass]="{ 'w-[794px]': isFromDiscovery, 'w-[calc(100%-16px)]': !isFromDiscovery }">
                      <div>
                        <mat-accordion>
                          <mat-expansion-panel
                            hideToggle
                            style="border-radius: 10px"
                            [togglePosition]="'before'"
                            (opened)="onPanelOpened(i)"
                            (closed)="onPanelClosed(i)"
                            (mouseenter)="mouseEnterHandler($event, assetExpansionPanel)"
                            #assetExpansionPanel
                            [expanded]="expandedItems().includes(i)"
                            class="institution-accordion-panel"
                            >
                            <!-- HEADER -->
                            <mat-expansion-panel-header [ngClass]="{ 'small-estate-panel': account.connection_status == 'CONNECTED' }" class="estate-panel">
                              <mat-panel-title style="align-items: center; margin: 0">
                                <span class="material-icons open mr-2">chevron_right</span>
                                <span class="material-icons close rotate-90 text-k-black font-normal opacity-100 mr-2">chevron_right</span>
                                <div class="pannel-continer">
                                  <div class="header">
                                    <div class="left flex items-center">
                                      <div class="flex items-center">
                                        <app-user-avatar size="36"
                                          src="{{ account?.institution?.small_logo_url }}"
                                          name="{{ account?.institution?.name | titlecase }}"
                        avatarClass="logo-img"
                                        ></app-user-avatar>
                                      </div>
                                      <div class="left-sub-div">
                                        <div class="flex items-center">
                                          <div
                                            class="title text-k-black font-semibold text-lg ml-2"
                                            [ngClass]="{ 'custom-position': account.connection_status != 'CONNECTED' }"
                                            [matTooltip]="account?.name"
                                            matTooltipPosition="above"
                                            >
                                            {{ account?.name | truncateStrPipe : (+account?.userAccounts?.length == 0 ? 17 : 24)
                                            }}<span class="mx-2">•</span>
                                            @if (+account?.userAccounts?.length > 0) {
                                              <span class="counter"> &nbsp;({{ account?.userAccounts?.length }}) </span>
                                            }
                                          </div>
                                          @if (+account?.userAccounts?.length > 0) {
                                            <div class="sub-title font-normal text-base text-k-black">{{ account?.userAccounts?.length }} Accounts</div>
                                            } @if (+account?.userAccounts?.length == 0) {
                                            <div class="sub-title font-normal text-base text-k-black">No Accounts</div>
                                          }
                                        </div>
                                      </div>
                                    </div>
                                    <div class="right-div flex items-center">
                                      @if (!isFromDiscovery) {
                                      <div class="link-credential-wrapper relative shrink-0 mr-1 flex items-center gap-2" (click)="$event.stopPropagation()" [attr.data-account-id]="getAccountId(account)">
                                        @if (hasLinkedTemplate(account)) {
                                          <div class="flex items-center gap-1">
                                            <div
                                              class="link-credential-selected flex items-center px-3 py-2 rounded-[3px] border border-[#d4dce8] bg-[#EBEBEB] text-[#18191C] text-[12px] font-medium cursor-pointer"
                                              (click)="onOpenLinkedTemplate(account)"
                                              [matTooltip]="getLinkedTemplate(account).template.form_name || getLinkedTemplate(account).template.type"
                                              matTooltipPosition="above"
                                            >
                                              <span class="flex-1 min-w-0">{{ (getLinkedTemplate(account).template.form_name || getLinkedTemplate(account).template.type) | truncateStrPipe : 24 }}</span>
                                              <button
                                                type="button"
                                                class="flex items-center justify-center w-4 h-4 rounded-full ml-1 border border-[#25508E] bg-[#EBEBEB] hover:bg-[#eee] transition shrink-0"
                                                (click)="$event.stopPropagation(); onUnlinkCredential(account, $event)"
                                              >
                                                <span class="material-icons text-[#25508E] text-sm">remove</span>
                                              </button>
                                            </div>
                                          </div>
                                        } @else {
                                        <div
                                          class="link-credential-input flex items-center gap-2 px-3 py-2 rounded-[3px] border border-[#d4dce8] bg-white min-w-[200px] max-w-[280px] cursor-pointer"
                                          (click)="openLinkCredentialDropdown(account)"
                                        >
                                          <img src="assets/images/search-gray-small-icon.svg" width="15" height="15" alt="" class="shrink-0" />
                                          <input
                                            type="text"
                                            [ngModel]="getAccountLinkCredentialSearch(account)"
                                            (ngModelChange)="setAccountLinkCredentialSearch(account, $event)"
                                            (click)="openLinkCredentialDropdown(account)"
                                            placeholder="Link Credential"
                                            class="outline-none flex-1 min-w-0 text-[12px] text-[#828282] font-open-sans font-medium leading-[18px] tracking-[-0.12px] bg-transparent border-0 placeholder:text-[#828282]"
                                          />
                                        </div>
                                        }
                                        @if (isLinkCredentialDropdownOpenFor(account) && linkCredentialDropdownPosition) {
                                          <div
                                            class="link-credential-dropdown fixed z-[9999] bg-white shadow-lg rounded-xl border border-[#e0e0e0] flex flex-col overflow-hidden"
                                            [style.top.px]="linkCredentialDropdownPosition.top"
                                            [style.left.px]="linkCredentialDropdownPosition.left"
                                            [style.width.px]="linkCredentialDropdownPosition.width"
                                          >
                                            <div class="max-h-[280px] overflow-y-auto py-2 flex-1 min-h-0">
                                              @if (isLoadingLinkCredentialTemplates) {
                                                <ul class="list-none p-0 m-0">
                                                  @for (placeholder of [1,2,3,4]; track placeholder) {
                                                    <li class="flex items-center gap-3 px-4 py-3 animate-pulse">
                                                      <div class="flex-shrink-0 w-10 h-10 rounded bg-[#e5e7eb]"></div>
                                                      <div class="flex flex-col gap-2 flex-1">
                                                        <div class="h-4 rounded bg-[#e5e7eb] w-3/4"></div>
                                                        <div class="h-3 rounded bg-[#e5e7eb] w-1/2"></div>
                                                      </div>
                                                      <div class="flex-shrink-0 w-20 h-7 rounded-full bg-[#e5e7eb]"></div>
                                                    </li>
                                                  }
                                                </ul>
                                              } @else if (linkCredentialFilteredTemplates.length > 0) {
                                                <ul class="list-none p-0 m-0 overflow-hidden">
                                                  @for (template of linkCredentialFilteredTemplates; track template.vault_form_id || template.id) {
                                                    <li
                                                      class="flex items-center gap-3 px-4 py-3 hover:bg-[#f5f5f5] cursor-pointer rounded-lg transition min-w-0 overflow-hidden"
                                                      (click)="onLinkCredentialTemplateSelect(account, template)"
                                                    >
                                                      <div class="flex items-center min-w-0 flex-1 overflow-hidden">
                                                        <div class="flex-shrink-0 w-10 h-10 rounded bg-[#f3f4f6] flex items-center justify-center mr-3">
                                                          @if (template.image) {
                                                            <img [src]="template.image" width="36" height="36" class="object-cover rounded" />
                                                          } @else {
                                                            <span class="material-icons text-[#b0b0b0] text-2xl">insert_drive_file</span>
                                                          }
                                                        </div>
                                                        <div class="flex flex-col items-start min-w-0 flex-1 overflow-hidden">
                                                          <span class="font-semibold text-[#18191C] text-base leading-5 block overflow-hidden text-ellipsis whitespace-nowrap w-full" [matTooltip]="template.form_name || template.type" matTooltipPosition="above">{{ (template.form_name || template.type) | truncateStrPipe : 13 }}</span>
                                                          <span class="text-xs text-[#898F9E] mt-1 block overflow-hidden text-ellipsis whitespace-nowrap w-full" [matTooltip]="template.type_template || ''" matTooltipPosition="above">{{ (template.type_template || '') | truncateStrPipe : 13 }}</span>
                                                        </div>
                                                      </div>
                                                      <div class="flex items-center gap-1 flex-shrink-0 rounded px-2 py-1 bg-[#f3f4f6] border border-[#5475C0]/40 overflow-hidden w-[110px]">
                                                        <span class="material-icons text-[#5475C0] text-sm flex-shrink-0">person</span>
                                                        <span class="text-xs text-[#5475C0] overflow-hidden text-ellipsis whitespace-nowrap min-w-0" [matTooltip]="template.vault_name || template.vaultname || template.uname || 'Personal'" matTooltipPosition="above">{{ (template.vault_name || template.vaultname || template.uname || 'Personal') | truncateStrPipe : 12 }}</span>
                                                      </div>
                                                    </li>
                                                  }
                                                </ul>
                                              } @else {
                                                <div class="p-3 text-center text-[#b0b0b0]">No credentials found</div>
                                              }
                                              </div>
                                            <div
                                              class="flex items-center justify-center px-4 w-full py-3 bg-[#EBF0FA] cursor-pointer border-t border-[#eee] flex-shrink-0 rounded-b-xl"
                                              (click)="openCreateNewCredential(account)"
                                            >
                                              <span class="text-[#25508E] font-semibold text-sm">+ Create New</span>
                                            </div>
                                          </div>
                                        }
                                      </div>
                                      }
                                      <div class="flex items-center gap-3">
                                        @if (account?.connection_status && account.connection_status !== 'CONNECTED') {
                                          <button
                                    (click)="
                                      $event.stopPropagation();
                                      account?.access_token ? reconnectToTheInstitutionThroughPlaid(account) : addInstitution()
                                    "
                                            class="cursor-pointer flex items-center h-8 bg-k-blue text-white rounded p-2 font-semibold text-[12px] gap-1"
                                            >
                                            <span class="material-icons text-white h-[20px] w-[20px] text-[20px]">refresh</span>
                                            Connect
                                          </button>
                                        }
                                        <img
                                    [src]="
                                      account?.guid ? '/assets/images/mx-financial-institution.svg' : '/assets/images/plaid-financial-institution.svg'
                                    "
                                          [matTooltip]="account?.guid ? 'Connected with MX' : 'Connected with Plaid'"
                                          matTooltipClass="customTooltip"
                                          />
                                        <img
                                    [src]="
                                      account?.connection_status === 'CONNECTED'
                                        ? '/assets/images/financial-institution-connected.svg'
                                        : '/assets/images/financial-institution-disconnected.svg'
                                    "
                                          customTooltip
                                          [customTooltipTitle]="account?.connection_status === 'CONNECTED' ? 'Active Connection' : 'Broken Connection'"
                                          [customTooltipSubtitle]="'Last Updated ' + ((account?.updated_at || account?.created_at) | date : 'MM/dd/yyyy')"
                                          />
                                      </div>
                                      <div class="popup-menu">
                                        <button
                                          mat-icon-button
                                          [matMenuTriggerFor]="menuItem"
                                          class="mobiel-button h-6 w-6 p-0 flex ml-3"
                                          (click)="$event.stopPropagation()"
                                          [disableRipple]="true"
                                          >
                                          <span class="material-icons" style="transform: rotate(0deg) !important">more_vert</span>
                                        </button>
                                        <mat-menu #menuItem="matMenu" yPosition="below" xPosition="before" class="popup-menu-panel w-[190px]">
                                          <button mat-menu-item class="popup-menu-item" (click)="disconnect(account)">
                                            <div class="flex items-center gap-2">
                                              <span class="material-icons menuitem-icon material-symbols-outlined material-icons-outlined text-xl m-0"
                                                >delete</span
                                                >
                                                <p class="menuitem-text text-sm font-semibold m-0">Delete Connection</p>
                                              </div>
                                            </button>
                                          </mat-menu>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </mat-panel-title>
                              </mat-expansion-panel-header>
                              <div style="margin: 0 -24px -24px -24px">
                                <individual-user-member
                                  [updated_at]="account.updated_at"
                                  (someEvent)="handleEmitEvents($event)"
                                  [userMembers]="account?.userAccounts"
                                  [unlinkedMxTemplates]="unlinkedMxTemplates"
                                  (selectedItemsEmitter)="handleSelectedAccounts($event)"
                                  [isFromDiscovery]="isFromDiscovery ? true : false"
                                  [selectedItemsArray]="selectedAccounts()"
                                  >
                                </individual-user-member>
                              </div>
                            </mat-expansion-panel>
                          </mat-accordion>
                        </div>
                      </div>
                    }
                  </div>
                </div>
                } @if (mxDatList().length == 0) {
                <div
                  class="flex justify-center items-center"
            [ngClass]="{
              'h-[calc(100vh-416px)]': isFromDiscovery && switchFromUser,
              'h-[calc(100vh-364px)]': isFromDiscovery && !switchFromUser,
              'h-[80%]': !isFromDiscovery
            }"
                  >
                  <div class="flex-center flex-col">
                    <img src="assets/images/financial-account__zero-state.svg" alt="No financial accounts connected" class="w-[220px] h-[196px] mb-6" />
                    <p class="text-[#53565B] text-lg font-semibold font-open-sans m-0">
                      No <span class="text-k-blue font-bold"> {{ isFromDiscovery ? 'Financial Integrations' : 'Financial Accounts' }}</span> to Show
                    </p>
                    @if(isFromDiscovery){
                      <div class="flex justify-center gap-2 mt-4">
                        <button type="button" class="btn integration-success" (click)="addInstitutionThroughPlaid()">
                          Connect with <img src="/assets/images/plaid-new-black-icon.svg" alt="" />
                        </button>
                        <button type="button" class="btn integration-success" (click)="addInstitution()">
                          Connect with <img src="/assets/images/mx-new-black-icon.svg" alt="" />
                        </button>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          } @else {
            <div class="loader-container mt-3 flex-col" [ngClass]="{ 'px-0 w-[794px]': isFromDiscovery, 'px-[32px]': !isFromDiscovery }">
              @for (item of loaderItems; track item) {
                <div class="w-full">
                  <div class="flex loader-body w-full" id="{{ item.id }}">
                    <div class="ph-item width-100per loader-body-item pt-[20px]">
                      <div class="ph-col-12 p-0">
                        <div class="ph-row">
                          <div class="ph-col-12 h-10 p-0 m-0"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </div>

  <div class="checklist-floater">
    @if (selectedAccounts().length) {
      <app-shared-floater-action
        [position]="embeddedFloaterPosition"
        [selectedCount]="selectedAccounts().length"
        [actions]="mxAccountFloaterActions"
        (actionClick)="onMxAccountFloaterAction($event)"
        (closeClick)="moveChecklists('clearSelection')"
      ></app-shared-floater-action>
    }
  </div>
